import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
      themes: {
        light: {
          primary: '#143983',
          secondary: '#b0bec5',
          accent: '#fb671a',
          error: '#b71c1c',
        },
      },
    },
  });


